/* src/app/modules/subscription/subscription.component_new.css */
.sub-splash {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1e2235;
  z-index: 2000;
  animation: sub-fadein 0.25s ease;
}
.sub-splash__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
}
.sub-splash__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(227, 253, 100, 0.15);
  animation: sub-slideup 0.45s ease 0.05s both;
}
.sub-splash__icon-wrap mat-icon {
  font-size: 34px;
  width: 34px;
  height: 34px;
  color: #e3fd64;
}
.sub-splash__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.87);
  animation: sub-slideup 0.45s ease 0.15s both;
}
.sub-splash__sub {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
  animation: sub-slideup 0.45s ease 0.25s both;
}
.sub-action-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(3px);
  z-index: 2000;
  animation: sub-fadein 0.2s ease;
}
.sub-action-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 48px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: sub-slideup 0.3s ease;
}
.sub-action__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
}
.sub-action__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #e3fd64;
}
.sub-action__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1d23;
}
.sub-action__sub {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
.sub-splash__dots {
  display: flex;
  gap: 8px;
}
.sub-splash__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.3;
  animation: sub-pulse 1.2s ease-in-out infinite;
}
.sub-splash__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.sub-splash__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes sub-fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes sub-slideup {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes sub-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.main-container {
  margin-left: 240px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.header {
  background-color: #fff;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
}
.header-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}
.header-tools {
  display: flex;
  align-items: center;
  gap: 20px;
  color: #64748b;
}
.content-body {
  padding: 30px 40px;
  padding-bottom: 130px;
  max-width: 100%;
  width: 100%;
}
.plan-card {
  background:
    linear-gradient(
      135deg,
      #1e293b 0%,
      #0f172a 100%);
  border-radius: 16px;
  padding: 20px 28px;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  position: relative;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
}
.badge-current {
  background-color: #3b3a30;
  color: #e3fd64;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  display: inline-block;
}
.plan-name {
  font-size: 1.55rem;
  font-weight: 700;
  margin-bottom: 4px;
}
.plan-status {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 0.82rem;
}
.status-dot {
  width: 8px;
  height: 8px;
  background-color: #22c55e;
  border-radius: 50%;
}
.plan-price-block {
  text-align: right;
}
.price-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #e3fd64;
}
.price-period {
  font-size: 0.8rem;
  color: #94a3b8;
  font-weight: 400;
}
.renewal-date {
  font-size: 0.74rem;
  color: #94a3b8;
  margin-top: 3px;
}
.cancellation-warning {
  color: #ef4444;
  font-weight: 600;
}
.pending-downgrade-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: rgba(227, 253, 100, 0.12);
  border: 1px solid rgba(227, 253, 100, 0.35);
}
.fiscal-profile-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.45);
}
.fiscal-profile-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  color: #e2e8f0;
  line-height: 1.5;
}
.fiscal-profile-text .mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #f59e0b;
}
.pending-downgrade-text {
  font-size: 0.82rem;
  color: #e2e8f0;
  line-height: 1.5;
}
.btn-upgrade {
  background-color: #e3fd64;
  color: #1a1c2c;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  margin-left: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 20px;
}
.label-icon {
  width: 20px;
  height: 20px;
  background-color: #e3fd64;
  border-radius: 4px;
}
.promo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 220px));
  gap: 14px;
  margin-bottom: 20px;
  justify-content: start;
}
.promo-card {
  background-color: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  min-height: 210px;
  max-width: 220px;
}
.promo-icon-box {
  width: 38px;
  height: 38px;
  background-color: #fffbeb;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 1rem;
}
.promo-title {
  font-size: 0.96rem;
  font-weight: 700;
  margin-bottom: 6px;
}
.promo-desc {
  font-size: 0.82rem;
  color: #64748b;
  line-height: 1.35;
  margin-bottom: 12px;
  flex-grow: 1;
}
.promo-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.price-strike {
  text-decoration: line-through;
  color: #94a3b8;
  margin-right: 6px;
  font-size: 0.78rem;
}
.price-free {
  color: var(--cf-brand-dark);
  font-weight: 700;
  font-size: 1.1rem;
}
.btn-activate {
  background: var(--cf-brand-dark);
  border: 1px solid var(--cf-brand-dark);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  border-radius: 8px;
  padding: 6px 10px;
  transition: background .15s ease, border-color .15s ease;
}
.btn-activate:hover {
  background: var(--cf-brand-dark);
  border-color: var(--cf-brand-dark);
}
.ocr-card {
  background-color: #fff;
  border-radius: 12px;
  padding: 18px;
  display: flex;
  gap: 20px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
  margin-bottom: 28px;
  width: 50%;
  max-width: 50%;
}
.ocr-controls {
  flex-grow: 1;
}
.ocr-title {
  font-size: 0.98rem;
  font-weight: 700;
  margin-bottom: 6px;
}
.ocr-subtitle {
  color: #64748b;
  font-size: 0.82rem;
  margin-bottom: 18px;
}
.slider-container {
  position: relative;
  padding: 4px 0;
}
.ocr-range {
  width: 100%;
  margin: 0;
  cursor: pointer;
  accent-color: var(--cf-brand-dark);
}
.slider-track {
  height: 5px;
  background: #e2e8f0;
  border-radius: 3px;
  width: 100%;
  position: relative;
}
.slider-thumb {
  width: 16px;
  height: 16px;
  background: var(--cf-brand-dark);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 25%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 0 4px rgba(212, 143, 0, 0.2);
}
.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 9px;
  color: #94a3b8;
  font-size: 0.68rem;
  font-weight: 600;
}
.estimation-box {
  width: 190px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.estimation-label {
  color: #64748b;
  font-size: 0.72rem;
  margin-bottom: 6px;
}
.estimation-value {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 10px;
}
.estimation-value span {
  font-size: 0.82rem;
  font-weight: 400;
  color: #94a3b8;
}
.estimation-cost {
  background-color: #fffbeb;
  color: #d97706;
  font-weight: 700;
  padding: 7px;
  border-radius: 8px;
  font-size: 0.78rem;
}
.footer-toolbar {
  border-top: 1px solid #e2e8f0;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 250px;
  right: 12px;
  z-index: 25;
  box-shadow: 0 -8px 20px rgba(15, 23, 42, 0.06);
}
.footer-left {
  display: flex;
  gap: 15px;
}
.btn-footer {
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
}
.btn-dark {
  background-color: #1a1c2c;
  color: #fff;
}
.btn-factuone {
  background: var(--cf-brand-dark);
  color: #ffffff;
  border: 1px solid var(--cf-brand-dark);
}
.btn-factuone:hover {
  background: #b8790a;
  border-color: #b8790a;
}
.btn-light {
  background-color: #f1f5f9;
  color: #1e293b;
}
.btn-cancel {
  color: #ef4444;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}
.change-plan-section {
  display: block;
  width: 100%;
  margin-top: 18px;
}
.change-plan-shell {
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
  border: 1px solid #e2e8f0;
  padding: 22px;
  display: flex;
  flex-direction: column;
}
.change-plan-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 18px;
}
.change-plan-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.change-plan-active-coupon {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: -4px 0 14px;
  max-width: 520px;
}
.change-plan-active-coupon .active-coupon-text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: .86rem;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 10px;
}
.change-plan-active-coupon .coupon-remove {
  border: none;
  background: transparent;
  color: #ef4444;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}
.change-plan-title {
  margin: 0;
  font-size: 1.55rem;
  font-weight: 700;
  color: #0f172a;
}
.change-plan-subtitle {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 0.95rem;
}
.change-plan-close {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 600;
  cursor: pointer;
}
.change-plan-grid {
  display: grid;
  grid-template-columns: 1fr 260px 220px;
  gap: 16px;
  align-items: stretch;
  flex: 1;
}
.change-plan-grid-only-plans {
  grid-template-columns: 1fr;
}
.change-plan-grid-only-plans .change-plan-cards {
  max-width: 1120px;
  margin: 0 auto;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.change-plan-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(155px, 1fr));
  gap: 14px;
  align-items: stretch;
}
.change-plan-card {
  width: 100%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  border-radius: 12px;
  padding: 14px;
  text-align: left;
  cursor: pointer;
  transition: border-color .15s, box-shadow .15s;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.change-plan-card:hover {
  border-color: var(--cf-brand-dark);
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
}
.change-plan-card-active {
  border-color: var(--cf-brand-dark);
  box-shadow: 0 0 0 2px rgba(212, 143, 0, 0.25);
}
.change-plan-card-current {
  opacity: 0.75;
}
.change-plan-card-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.change-plan-card-name {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}
.change-plan-card-price {
  font-size: 1rem;
  font-weight: 700;
  color: #f59e0b;
  white-space: nowrap;
}
.change-plan-card-price span {
  font-size: .8rem;
  font-weight: 500;
  color: #64748b;
  margin-left: 2px;
}
.change-plan-features {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 3px;
  flex: 1;
  align-content: start;
}
.change-plan-features li {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: #475569;
  font-size: .86rem;
  line-height: 1.12;
}
.change-plan-features li.bold {
  font-weight: 700;
  color: #1e293b;
}
.change-plan-features mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #f59e0b;
  margin-top: 0;
}
.change-plan-summary,
.change-plan-enterprise {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.change-plan-summary h3,
.change-plan-enterprise h3 {
  margin: 0 0 10px;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}
.period-switch {
  display: flex;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 3px;
  margin-bottom: 12px;
}
.period-switch button {
  flex: 1;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #334155;
  font-weight: 600;
  font-size: .85rem;
  padding: 7px;
  cursor: pointer;
}
.period-switch button.active {
  background: #1e293b;
  color: #fff;
}
.summary-item,
.summary-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  font-size: .9rem;
  color: #334155;
}
.summary-total-row {
  border-top: 1px solid #e2e8f0;
  margin-top: 10px;
  padding-top: 10px;
  font-size: 1rem;
}
.summary-legend {
  margin: 8px 0 0;
  color: #64748b;
  font-size: .8rem;
}
.discount-row .discount-amount {
  color: #16a34a;
}
.change-plan-summary .btn.btn-convfact {
  margin-top: auto;
}
.coupon-mini {
  margin-top: 12px;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.change-plan-summary .coupon-toggle-btn,
.change-plan-active-coupon .coupon-toggle-btn {
  width: 100%;
  border: none;
  border-radius: 8px;
  padding: 9px 12px;
  font-weight: 700;
  font-size: 0.9rem;
  background: #1a1c2c;
  color: #ffffff;
  cursor: pointer;
  transition: background .15s ease;
}
.change-plan-summary .coupon-toggle-btn:hover,
.change-plan-active-coupon .coupon-toggle-btn:hover {
  background: #101726;
}
.change-plan-summary .coupon-input,
.change-plan-active-coupon .coupon-input {
  margin-top: 2px;
}
.change-plan-summary .coupon-input .input-group,
.change-plan-active-coupon .coupon-input .input-group {
  display: flex;
  gap: 8px;
}
.change-plan-summary .coupon-input .form-control,
.change-plan-active-coupon .coupon-input .form-control {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  min-height: 40px;
  box-shadow: none;
}
.change-plan-summary .coupon-input .btn.btn-convfact,
.change-plan-active-coupon .coupon-input .btn.btn-convfact {
  min-width: 100px;
  border-radius: 8px;
  font-weight: 700;
}
.applied-coupon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}
.coupon-tag {
  color: #334155;
  font-size: 0.88rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}
.coupon-remove {
  border: none;
  background: transparent;
  color: #ef4444;
  width: 24px;
  height: 24px;
  font-size: 20px;
  line-height: 1;
  border-radius: 999px;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.coupon-remove:hover {
  background: rgba(239, 68, 68, 0.12);
}
.change-plan-enterprise p {
  margin: 0 0 12px;
  color: #64748b;
  font-size: .9rem;
  line-height: 1.4;
  flex: 1;
}
.btn-outline {
  border: 1px solid #1e293b;
  background: #fff;
  color: #1e293b;
  border-radius: 8px;
  padding: 9px 12px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
}
.status-dot-trial {
  background-color: var(--cf-brand-dark) !important;
}
.status-dot-canceled {
  background-color: #ef4444 !important;
}
.trial-days-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  background: rgba(212, 143, 0, 0.15);
  color: var(--cf-brand-dark);
  font-size: 0.8rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid rgba(212, 143, 0, 0.3);
}
.trial-plan-section {
  margin-top: 28px;
}
.trial-plan-header {
  margin-bottom: 20px;
}
.trial-plan-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}
.trial-plan-subtitle {
  font-size: 0.88rem;
  color: #64748b;
  margin: 0;
}
.trial-plan-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 16px;
  align-items: start;
}
.trial-plan-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  align-items: stretch;
  grid-column: 1;
}
.trial-plan-sidebar {
  grid-column: 2;
  display: flex;
  flex-direction: column;
  align-self: start;
}
.trial-plan-grid .change-plan-summary {
  grid-column: 2;
  min-width: 0;
  height: auto;
}
.trial-contact-card {
  cursor: default;
  justify-content: space-between;
  min-height: 100%;
}
.trial-contact-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
}
.trial-contact-body p {
  margin: 0;
  color: #64748b;
  font-size: .92rem;
  line-height: 1.45;
}
.trial-contact-btn {
  margin-top: auto;
}
.trial-plan-grid .change-plan-summary .summary-item,
.trial-plan-grid .change-plan-summary .summary-total-row {
  align-items: flex-start;
}
.trial-plan-grid .change-plan-summary .summary-item strong,
.trial-plan-grid .change-plan-summary .summary-total-row strong {
  white-space: nowrap;
}
.trial-plan-grid .change-plan-summary .btn.btn-convfact {
  margin-top: 12px;
}
@media (max-width: 1180px) {
  .main-container {
    margin-left: 0;
  }
  .content-body {
    padding: 16px;
    padding-bottom: 250px;
  }
  .plan-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
  }
  .plan-price-block {
    text-align: left;
  }
  .promo-grid {
    grid-template-columns: 1fr;
  }
  .promo-card {
    max-width: none;
  }
  .ocr-card {
    width: 100%;
    max-width: 100%;
  }
  .trial-plan-grid {
    grid-template-columns: 1fr;
  }
  .trial-plan-cards {
    grid-template-columns: 1fr;
    grid-column: auto;
  }
  .trial-plan-sidebar,
  .trial-plan-grid .change-plan-summary,
  .trial-contact-card {
    grid-column: auto;
    width: 100%;
  }
  .footer-toolbar {
    left: 12px;
    right: 12px;
    bottom: 0;
    padding: 12px;
    gap: 8px;
    align-items: stretch;
    flex-direction: column;
  }
  .footer-left {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
  }
  .btn-footer {
    width: 100%;
    justify-content: center;
    padding: 10px 12px;
    font-size: 0.85rem;
  }
  .btn-cancel {
    align-self: flex-start;
    padding-left: 2px;
  }
  .change-plan-section {
    margin-top: 12px;
  }
  .change-plan-shell {
    width: 100%;
    padding: 14px;
  }
  .change-plan-grid {
    grid-template-columns: 1fr;
  }
  .change-plan-cards {
    grid-template-columns: 1fr;
  }
  .change-plan-summary,
  .change-plan-enterprise,
  .change-plan-card {
    height: auto;
  }
}
@media (max-width: 560px) {
  .footer-left {
    grid-template-columns: 1fr;
  }
}
.payment-pending-card {
  display: block;
  max-width: 620px;
}
.payment-pending-status {
  margin-bottom: 8px;
}
.payment-pending-header .plan-name {
  margin: 4px 0 6px;
}
.payment-pending-header .change-plan-subtitle {
  margin: 0;
}
.payment-pending-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 16px;
}
.payment-pending-amount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 12px;
  color: #9a3412;
  font-size: 1rem;
}
.payment-pending-amount strong {
  font-size: 1.2rem;
  color: #7c2d12;
}
.payment-pending-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.payment-pending-actions .btn.btn-convfact {
  flex: 1 1 auto;
  min-width: 160px;
}
.payment-pending-outline {
  width: auto;
  flex: 0 0 auto;
}
.payment-pending-reason {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  color: #b91c1c;
  font-size: 0.9rem;
  line-height: 1.4;
}
.payment-pending-reason mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}
.payment-pending-legend {
  margin: 0;
  color: #64748b;
  font-size: 0.85rem;
  line-height: 1.4;
}
.plan-payment-method {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  color: #64748b;
  font-size: 0.85rem;
}
.plan-payment-method mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.payment-processing-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 14px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  color: #1d4ed8;
  font-size: 0.9rem;
  line-height: 1.4;
}
.payment-processing-note mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 12px;
}
.spinner-container {
  text-align: center;
  color: #444;
  font-family: "Inter Tight", sans-serif;
}
.loading-text {
  margin-top: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #555;
  animation: fadeIn 1.5s ease-in-out infinite alternate;
}
@keyframes fadeIn {
  from {
    opacity: 0.6;
  }
  to {
    opacity: 1;
  }
}
/*# sourceMappingURL=subscription.component_new.css.map */
